import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PushNotificationRoutingModule } from './push-notification-routing.module';
import { PushNotificationsComponent } from './push-notifications/push-notifications.component';
import { AddUpdatePushNotificationsComponent } from './add-update-push-notifications/add-update-push-notifications.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PushNotificationDetailsComponent } from './push-notification-details/push-notification-details.component';

@NgModule({
  declarations: [
    PushNotificationsComponent,
    AddUpdatePushNotificationsComponent,
    PushNotificationDetailsComponent,
  ],
  imports: [CommonModule, PushNotificationRoutingModule, SharedModule],
})
export class PushNotificationModule {}
